/* __next_internal_client_entry_do_not_use__ ProductTileTrackingWrapper auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { useEffectEvent } from "@faire/web--source/ui/hooks/useEffectEvent";
import React from "react";
import { useProductTileViewImpression } from "@faire/retailer/hooks/ProductTileImpression/useProductTileViewImpression";
import { assignSettingOnEvent } from "@faire/retailer/settings/assignSettingOnEvent";
import { useGetProductTileClickImpressions } from "../../productTileActions/useGetProductTileClickImpressions";
export var ProductTileTrackingWrapper = function(param) {
    var _param_data = param.data, productToken = _param_data.productToken, isPromoted = _param_data.isPromoted, impressionId = _param_data.impressionId, promotedBy = _param_data.promotedBy, badgeList = _param_data.badgeList, bestImage = _param_data.bestImage, images = _param_data.images, settingsToAssignOnView = _param_data.settingsToAssignOnView, _param_data_recordProductTileImpressionForAds = _param_data.recordProductTileImpressionForAds, recordProductTileImpressionForAds = _param_data_recordProductTileImpressionForAds === void 0 ? false : _param_data_recordProductTileImpressionForAds, children = param.children;
    var trackProductTileProps = useProductTileViewImpression({
        productToken: productToken,
        promotedBy: promotedBy,
        impressionId: impressionId,
        turnOffTracking: recordProductTileImpressionForAds
    });
    var _useGetProductTileClickImpressions = useGetProductTileClickImpressions({
        token: productToken,
        isPromoted: isPromoted,
        impressionId: impressionId,
        promotedBy: promotedBy,
        badgeList: badgeList,
        bestImage: bestImage,
        images: images
    }), recordProductTileRightClickEvent = _useGetProductTileClickImpressions.recordProductTileRightClickEvent, recordProductTileMiddleClickEvent = _useGetProductTileClickImpressions.recordProductTileMiddleClickEvent;
    var settingAssignmentRef = useDoActionWhenVisible(function() {
        settingsToAssignOnView === null || settingsToAssignOnView === void 0 ? void 0 : settingsToAssignOnView.forEach(function(setting) {
            assignSettingOnEvent(setting);
        });
    });
    var handleOnAuxClick = useEffectEvent(function(event) {
        if (event.button === 1) {
            recordProductTileMiddleClickEvent();
        } else if (event.button === 2) {
            recordProductTileRightClickEvent();
        }
    });
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({}, trackProductTileProps), {
        onAuxClick: handleOnAuxClick,
        ref: function(element) {
            var _trackProductTileProps_ref;
            settingAssignmentRef(element);
            trackProductTileProps === null || trackProductTileProps === void 0 ? void 0 : (_trackProductTileProps_ref = trackProductTileProps.ref) === null || _trackProductTileProps_ref === void 0 ? void 0 : _trackProductTileProps_ref.call(trackProductTileProps, element);
        },
        children: children
    }));
};
